module.exports = __webpack_public_path__ + "img/ИФ-1(А)-013.5f1b5e63.png";